/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AnnouncementTypeEnum = "System_Release" | "Terms_And_Conditions" | "%future added value";
export type AnnouncementsBell_data = {
    readonly announcementsBellData: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly title: string;
                readonly content: string;
                readonly id: string;
                readonly type: AnnouncementTypeEnum | null;
                readonly displayType: string;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "AnnouncementsBell_data";
};
export type AnnouncementsBell_data$data = AnnouncementsBell_data;
export type AnnouncementsBell_data$key = {
    readonly " $data"?: AnnouncementsBell_data$data;
    readonly " $fragmentRefs": FragmentRefs<"AnnouncementsBell_data">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnnouncementsBell_data",
  "selections": [
    {
      "alias": "announcementsBellData",
      "args": [
        {
          "kind": "Literal",
          "name": "where",
          "value": {
            "disabled": false,
            "includeAcknowledged": true
          }
        }
      ],
      "concreteType": "AnnouncementConnection",
      "kind": "LinkedField",
      "name": "announcements",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AnnouncementEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Announcement",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "content",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayType",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "announcements(where:{\"disabled\":false,\"includeAcknowledged\":true})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
(node as any).hash = '5ff51df137357b97f34c40ed6c0c2c54';
export default node;
